import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useEffect, useState } from "react";

const BackToDemoButton = () => {
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    // Check if user came from demo page
    const fromDemo = sessionStorage.getItem('fromDemo');
    setShowButton(fromDemo === 'true');
  }, []);

  const handleBackToDemo = () => {
    sessionStorage.removeItem('fromDemo');
    navigate('/demo');
  };

  if (!showButton) return null;

  return (
    <button
      onClick={handleBackToDemo}
      className="fixed bottom-20 right-6 z-50 flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-full shadow-lg font-medium transition-all hover:scale-105"
    >
      <ArrowLeft size={20} />
      Back to Demo
    </button>
  );
};

export default BackToDemoButton;
